{
  "name": "@tscratch3/typescratcher",
  "version": "0.1.48",
  "description": "TypeScript library that generates Scratch3-style drawings",
  "repository": {
    "type": "git",
    "url": "git://github.com/amami-harhid/typeScratcher.git"
  },
  "publishConfig": {
    "access": "public"
  },
  "files": [
    "build",
    "src/lib",
    "src/type",
    "eslint",
    "eslint-plugin",
    "index.ts"
  ],
  "author": "amami-harhid",
  "license": "AGPL-3.0-only",
  "main": "./index.ts",
  "type": "module",
  "scripts": {
    "dev": "vite --open",
    "build": "npm run buildWithConfig && npm run copyDts && npm run buildPlugins && npm run copyVitePluginDts",
    "buildWithConfig": "vite build --config ./vite.config-build.js --emptyOutDir",
    "copyDts": "copy public\\typescratcher.d.ts build\\",
    "buildPlugins": "vite build --config ./vite.config-build-plugins.js --emptyOutDir",
    "copyVitePluginDts": "copy public\\vitePlugins\\index.d.ts build\\vitePlugins\\index.d.ts"
  },
  "dependencies": {
    "@ampproject/remapping": "^2.3.0",
    "@babel/parser": "^7.27.1",
    "@eslint/js": "^9.26.0",
    "@stylistic/eslint-plugin": "^5.10.0",
    "@types/events": "^3.0.3",
    "@types/glob": "^9.0.0",
    "@types/node": "^25.9.1",
    "buffer": "^6.0.3",
    "core-js": "^3.49.0",
    "eslint": "^9.26.0",
    "events": "^3.3.0",
    "glob": "^10.5.0",
    "globals": "^14.0.0",
    "magic-string": "^1.1.1",
    "regenerator-runtime": "^0.14.1",
    "scratch-audio": "^2.0.139",
    "scratch-render": "^2.0.356",
    "ts-morph": "^28.0.0",
    "twgl.js": "^4.24.0",
    "typescript": "^6.0.3",
    "typescript-eslint": "^8.60.1",
    "vite": "^8.2.1",
    "vite-plugin-checker": "^0.14.5"
  },
  "devDependencies": {
    "vite-plugin-dts": "^5.0.3"
  }
}
